import styled from 'styled-components';

import { H4 } from '~/components/Typography';

export default styled(H4)<{}>`
  margin-top: 3em;
`;
